// extracted by mini-css-extract-plugin
export default {"iconWrapper":"Icon_iconWrapper__om2G+"};